import React, { Dispatch, useCallback, useEffect, useRef, useState } from "react";
import Draggable from "react-draggable";
import "../../App.css";

import { ResizableBox, ResizeCallbackData } from "react-resizable";
import { Coordinate } from "ol/coordinate";
import SummeryEWS from "./SummeryEWS";
import ReportedIncidentsDataTable from "./ReportedIncidentsDataTable";
import { earlyWarning } from "../earlyWarning/ShowEarlyWarning";
import { hzIncidents } from "../hazardIncidentsLayers/IncidentsMenuDropDown";
import { ItemTypes } from "../../initial/menu/RightSideMenu";


interface Props {
    onClose: () => void; 
    earlyWarningsFromChild:earlyWarning[];
    hzDatafromSummery:hzIncidents[];
    addItem?: (id: string, type: ItemTypes) => void;
    id?: string;
}

const areaRiverGauges = new Map<string, string>();

const SummeryFull: React.FC<Props> = ({onClose ,earlyWarningsFromChild,hzDatafromSummery,addItem,id
}) => {
  const [showDialog, setShowDialog] = useState<boolean>(true);
  const [activeFullScreen, setActiveFullScreen] = useState<boolean>(false);
  const fullscreenModal = useRef<HTMLDivElement | null>(null);
  const [dimensions, setDimensions] = useState({
    resizableBoxwidth: 0,
    resizableBoxheight: 0,
  });

  const [dimensionsMin, setDimensionsMin] = useState({
    resizableBoxMinwidth: 0,
    resizableBoxMinheight: 0,
  });
  //----------------resibleBox Function----------------
  const updateDimensions = () => {
    const vw = Math.max(
      document.documentElement.clientWidth || 0,
      window.innerWidth || 0
    );
    const vh = Math.max(
      document.documentElement.clientHeight || 0,
      window.innerHeight || 0
    );
    if (vw > 2000 && vh > 1200) {
      setDimensions({
        resizableBoxwidth: vw * 0.3,
        resizableBoxheight: vh * 0.3,
      });
    } else {
      setDimensions({
        resizableBoxwidth: vw * 0.6,
        resizableBoxheight: vh * 0.76,
      });
    }

    if (vw > 2000 && vh > 1200) {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.2,
        resizableBoxMinheight: vh * 0.3,
      });
    } else {
      setDimensionsMin({
        resizableBoxMinwidth: vw * 0.3,
        resizableBoxMinheight: vh * 0.4,
      });
    }
  };

  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  const openContentFullscreen = () => {
    if (!document.fullscreenElement) {
      enterFullscreen();
    } else {
      exitFullScreen();
    }
  };

  const enterFullscreen = () => {
    const elem = fullscreenModal.current;
    if (elem) {
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      }
      setActiveFullScreen(true);
    }
  };

  const exitFullScreen = () => {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if ((document as any).mozCancelFullScreen) {
      (document as any).mozCancelFullScreen();
    } else if ((document as any).webkitExitFullscreen) {
      (document as any).webkitExitFullscreen();
    } else if ((document as any).msExitFullscreen) {
      (document as any).msExitFullscreen();
    }
    setActiveFullScreen(false);
  };

  const [widthMain, setWidthMain] = useState<number>(0);
  const [heightMain, setHeightMain] = useState<number>(0);

  useEffect(() => {}, [widthMain, heightMain]);

  const handleResize = (
    event: React.SyntheticEvent,
    data: ResizeCallbackData
  ) => {
    setWidthMain(data.size.width);
    setHeightMain(data.size.height);
  };

  const closePopup = () => {
    setShowDialog(false);
    onClose(); 
  };


  // Nearest river gauges status
  const [isNearestRiverGaugeOpen, setIsNearestRiverGaugeOpen] =
    useState<boolean>(true);
  // Nearest rainfall gauges status
  const [isNearestRainfallGaugeOpen, setIsNearestRainfallGaugeOpen] =
    useState<boolean>(false);
  // Nearest early warning status
  const [isNearestReportedIncidentOpen, setIsNearestReportedIncidentOpen] =
    useState<boolean>(true);

    const popupRef = useRef<HTMLDivElement | null>(null)
  const enteredRef = useRef<boolean>(false)

  const mouseMoveEvent = useCallback((event: MouseEvent) => {
    const sideMenu = document.getElementById('side-menu-wrapper');
    
    if (sideMenu && !enteredRef.current) {
        const sideMenuWidth = Number(window.getComputedStyle(sideMenu).left.slice(0, -2));

        if (sideMenuWidth < event.clientX) {
    
          enteredRef.current = true
          if(id && addItem){
           addItem(id, 'info')
            /* props.windowState(false) */
            setShowDialog(false)
          }
        }
    }
}, [])

  useEffect(() => {
    const handleMouseDown = () => {
        document.addEventListener('mousemove', mouseMoveEvent);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleMouseUp = () => {
        document.removeEventListener('mousemove', mouseMoveEvent);
    };

    if (popupRef.current) {
        popupRef.current.addEventListener('mouseenter', () => {
            popupRef.current?.addEventListener('mousedown', handleMouseDown);
        });
    }

    return () => {
        document.removeEventListener('mousemove', mouseMoveEvent);
        document.removeEventListener('mouseup', handleMouseUp);
    };
  }, [mouseMoveEvent])

  return (
    <div
      className="ol-overlay-container ol-selectable"
      style={{
        width: "10px",
        height: "10px",
      }}
    >
      <div
        style={{ visibility: showDialog ? "visible" : "hidden", width: "0%" }}
      >
        <Draggable
          handle=".drag-handle"
          cancel=".no-drag"
          enableUserSelectHack={false}
        >
          <ResizableBox
            className="custom-resizable-box"
            width={dimensions.resizableBoxwidth}
            height={dimensions.resizableBoxheight}
            minConstraints={[
              dimensionsMin.resizableBoxMinwidth,
              dimensionsMin.resizableBoxMinheight,
            ]}
            onResize={handleResize}
            /* maxConstraints={[800, 600]} */
            resizeHandles={["s", "se", "sw", "ne", "nw"]}
            // style={{ zIndex: 1, left: "-30vw", right: "0vw", top: "-40vh" }}
          >
            <div
              className="drag-handle"
              ref={fullscreenModal}
              style={{
                width: "100%",
                height: "100%",
                position: "absolute",
                cursor: "move",
                touchAction: "none",
              }}
            >
              <div className={`earlyWarningPopupContainer`}>
                <div className={`titleContainer`}  ref={popupRef}>
                  <span>More Details</span>
                  <div className={`titleButtonContainer`}>
                    <i
                      className={`titleIcon fullScreenIco`}
                      onClick={openContentFullscreen}
                      onTouchStart={openContentFullscreen}
                    ></i>
                    <i
                      className={`titleIcon closeIco`}
                      onClick={() => closePopup()}
                      onTouchEnd={() => closePopup()}
                    ></i>
                  </div>
                </div>

                {/* Real-time tab data container */}

                <div className={`tabRealtimeDataContainer`}>
                  {/* Nearest river gauges */}

                  {earlyWarningsFromChild.length !==0 && (
                  <div className={`mapContainer`}>
                    <div
                      className={`titleContainer`}
                      style={{
                        borderRadius: `${
                          isNearestRiverGaugeOpen
                            ? "0.5rem 0.5rem 0 0"
                            : "0.5rem"
                        }`,
                      }}
                      onClick={(e) =>
                        setIsNearestRiverGaugeOpen((prevState) => !prevState)
                      }
                      onTouchStart={(e) =>
                        setIsNearestRiverGaugeOpen((prevState) => !prevState)
                      }
                    >
                      <span>Active Early Warnings - Last 24 hours</span>
                      <i
                        className={`${isNearestRiverGaugeOpen ? "up" : "down"}`}
                      ></i>
                    </div>
                    {isNearestRiverGaugeOpen && (
                      <div className={`mapDetailsContainer`}>
                    <SummeryEWS earlyWarningsFromChild={earlyWarningsFromChild}/>
                      </div>
                    )}
                  </div>
                  )}
                  {/* Nearest reported incident */}

                  <div className={`mapContainer`}>
                    <div
                      className={`titleContainer`}
                      style={{
                        borderRadius: `${
                          isNearestReportedIncidentOpen
                            ? "0.5rem 0.5rem 0 0"
                            : "0.5rem"
                        }`,
                      }}
                      onClick={(e) =>
                        setIsNearestReportedIncidentOpen(
                          (prevState) => !prevState
                        )
                      }
                      onTouchStart={(e) =>
                        setIsNearestReportedIncidentOpen(
                          (prevState) => !prevState
                        )
                      }
                    >
                      <span>Incidents - Last 24 hours</span>
                      <i
                        className={`${
                          isNearestReportedIncidentOpen ? "up" : "down"
                        }`}
                      ></i>
                    </div>
                    {isNearestReportedIncidentOpen && (
                      <div className={`mapDetailsContainer`}>
                     <ReportedIncidentsDataTable hzDatafromSummery={hzDatafromSummery}/>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </ResizableBox>
        </Draggable>
      </div>
    </div>
  );
};

export default SummeryFull;
